import React from 'react';
import { Redirect } from 'react-router-dom';

// Temporary file to handle wrong URL sent in email campaign
export default () => {
    return <Redirect to="/fees-insights" />;
};
